import { render, staticRenderFns } from "./InitialLoading.vue?vue&type=template&id=90396fb6&scoped=true"
import script from "./InitialLoading.vue?vue&type=script&lang=js"
export * from "./InitialLoading.vue?vue&type=script&lang=js"
import style0 from "./InitialLoading.vue?vue&type=style&index=0&id=90396fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90396fb6",
  null
  
)

export default component.exports